import React from 'react';
import { TextWithIcon } from '../index.js';

const PaymentMethod = ({ slug, iconSize = 14, iconColor, gap = 4 }) => {
  const getNameAndIcon = (slug) => {
    switch (slug) {
      case 'cash-on-delivery':
        return {
          name: 'Cash on Delivery',
          icon: 'BsCash',
        };
      case 'online-payment':
        return {
          name: 'Credit/Debit Card',
          icon: 'BsCreditCardFill',
        };
    }
  };

  return (
    <TextWithIcon
      iconColor={iconColor}
      iconSize={iconSize}
      gap={gap}
      text={getNameAndIcon(slug)?.name}
      icon={getNameAndIcon(slug)?.icon}
    />
  );
};

export default PaymentMethod;
